import React, { useState, useEffect, useContext } from "react";
import { StyledForm, paddingStyle } from "./style.module";
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { Row } from "react-bootstrap";
import { Transfer } from 'antd';
import { PricingPortalAPI } from "../../../../apis/pricing-api";
import { useSelector } from "react-redux";
import { selectSessionConfig } from "../../../../store/store-selector";
import { DisplaySpinnerContext } from "../../../../context/ContextIndex";
import { UserRoles } from "../../../../AppConstants";
import debounce from 'lodash/debounce';


export const FormTransfer = ({
  id,
  elementkey,
  isMandatory,
  label,
  error,
  userEmail,
  onSelect,
  formStateData,
  setFormStateData,
}) => {

  const [userRole, setUserRole] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const settingsConfig = useSelector(selectSessionConfig);
  const spinnerCtx = useContext(DisplaySpinnerContext);

  useEffect(() => {
    // Function available user roles
    const fetchUserRoles = async () => {
      try {
        let _userRole = await PricingPortalAPI.getList(
          settingsConfig.businessCode,
          settingsConfig.countryCode,
          "getUserRoleList",
          "userrolevantage"
        );
        //remove super admin role from the user role list
        const roles = _userRole.filter(role => role.UserRoleCode !== UserRoles.SuperAdmin);
        const formattedRoles = roles.map(role => ({
          key: role.UserRoleId,
          title: role.UserRoleDescription,
          description: role.UserRoleCode
        }));
        setUserRole(formattedRoles);
        spinnerCtx.setLoadingIndicator(false);
      } catch (error) {
        console.error('Failed to fetch user roles:', error);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    fetchUserRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //fetch added user role
  const fetchEmpUserRole = async () => {
    try {
      let empUserRoleResponse = await PricingPortalAPI.getList(
        settingsConfig.businessCode,
        settingsConfig.countryCode,
        "getAllUserWithRolesList",
        "userroles",
        { userEmail: userEmail }
      );

      //removing super admin user role code as we will not allow user to add super admin in portal
      const filteredEmpUserRoleResponse = empUserRoleResponse.filter(role => role.UserRoleCode !== UserRoles.SuperAdmin);

      const userRoleIds = filteredEmpUserRoleResponse.map(role => role.UserRoleId);
      const userRoleMappingIds = filteredEmpUserRoleResponse.map(role => role.UserRoleMappingId);

      let _formData = { ...formStateData.formData };
      _formData.UserRoleCode.userRoleMappingId = userRoleMappingIds;
      setFormStateData((prevData) => ({
        ...prevData,
        formData: _formData,
      }));


      setTargetKeys(userRoleIds);
      setSelectedKeys();
      callOnSelect(userRoleIds);
      spinnerCtx.setLoadingIndicator(false);
    } catch (error) {
      console.error('Failed to fetch emp user role:', error);
    }
  };

  useEffect(() => {
    const debouncedFetchEmpUserRole = debounce(() => {
      spinnerCtx.setLoadingIndicator(true);
      fetchEmpUserRole();
    }, 2000);
    if (userEmail) {
      debouncedFetchEmpUserRole();
    } else {
      setTargetKeys();
      setSelectedKeys();
      callOnSelect();
    }

    return () => {
      debouncedFetchEmpUserRole.cancel();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userEmail]);

  //save value in formData

  const callOnSelect = (nextTargetKeys = []) => {
    let selectedDescriptions = [];
    if (nextTargetKeys.length > 0) {
      selectedDescriptions = nextTargetKeys.map(key => userRole.find(item => item.key === key)?.description);
    }
    onSelect({
      target: {
        id: id,
        value: nextTargetKeys,
        description: selectedDescriptions,
      }
    });
  }
  // Handle change
  const handleChange = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys);
    callOnSelect(nextTargetKeys);
  };


  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  return (
    <StyledForm.Group
      as={Row}
      lg="8"
      controlId={id}
      style={paddingStyle}
      key={elementkey}
    >
      <StyledForm.Label style={{ marginTop: '15px' }}>
        {isMandatory && <FormMandatoryIcon />}
        {label}
      </StyledForm.Label>
      <Transfer
        dataSource={userRole}
        titles={['Available Roles', 'Assigned Roles']}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onChange={handleChange}
        onSelectChange={handleSelectChange}
        render={item => item.title}
        listStyle={{
          width: 300,
          height: 200
        }}
      />
      {error && (
        <div style={{ color: "#DC3545", fontSize: "0.700rem", marginTop: "0.25rem" }}>
          {error}
        </div>
      )}
    </StyledForm.Group>
  );
};
